<template>
	<Resize id="app" class="app-layout">
		<header-component></header-component>
		<div v-if="Helpers.isTouch()" class="mobileWrapper">
			<landing v-if="isLandingPage"></landing>
			<router-view v-else></router-view>
		</div>
		<div v-else class="deskWrapper">
			<landing v-if="isLandingPage"></landing>
			<div v-else class="pages-wrapper" @DOMMouseScroll="onMouseWheel" @mousewheel="onMouseWheel">
				<router-view></router-view>
			</div>
		</div>

		<footer-component></footer-component>
		<transition name="show-popup" appear>
			<base-popup v-if="popup"></base-popup>
		</transition>
	</Resize>
</template>

<script>

	import Resize from '@/components/common/Resize';
	import HeaderComponent from '@/components/parts/Header';
	import FooterComponent from '@/components/parts/Footer';
	import landing from '@/components/pages/landing';
	import BasePopup from '@/components/popups/BasePopup';

	import Helpers from '@/tools/Helpers'

	const PAGES = [
		'Index',
		'Rules'
	];

	let lastScrollTime = new Date().getTime();

	const LandingRoutes = ['Rules', 'Test', 'Video', 'Product'];

	export default {
		name: 'app',
		components: {
			Resize,
			HeaderComponent,
			FooterComponent,
			landing,
			BasePopup,
			Helpers
		},
		watch: {
			'$route.name'(val){
				Helpers.ga().send('click','Страница ' + val);
			}
		},
		data() {
			return {
				Helpers,
				transitionName: 'fade'
			}
		},
		computed: {
			popup() {
				return this.$store.getters['GET_POPUP'];
			},
			isLandingPage() {
				return LandingRoutes.indexOf(this.$route.name) >= 0;
			},
			routeName() {
				return this.$route.name;
			},
			canScroll() {
				return this.$store.getters['GET_LOAD_ANIMATE'];
			},
			animated() {
				return this.$store.getters['GET_ANIMATED'];
			}

		},

		methods: {

			onMouseWheel(e) {
				let scrollTime = new Date().getTime();
				let lScroll = lastScrollTime;
				lastScrollTime = scrollTime;

				if(!this.animated) {
					return;
				}
				if (scrollTime - lScroll < 250 ) return;

				let delta = e.deltaY || e.detail || e.wheelDelta;
				if (delta > 0) {
					this.nextPage();
				} else {
					this.prevPage();
				}
			},
			nextPage() {
				let index = PAGES.indexOf(this.routeName) + 1;
				let next = typeof PAGES[index] !== 'undefined' ? PAGES[index] : false;

				if (next && index) {
					console.log(index, next);
					this.$router.push({name: next});
				}
			},
			prevPage() {
				let index = PAGES.indexOf(this.routeName) - 1;
				let prev = typeof PAGES[index] !== 'undefined' ? PAGES[index] : false;

				if (prev) {
					this.$router.push({name: prev});
				}
			}
		}
	};

</script>

<style lang="scss" scoped>
	.fade-enter-active, .fade-leave-active {
		opacity: 1;
		transition: opacity 2s;
	}

	.fade-leave-active, .fade-leave-to {
		transition: opacity 2s;
	}


</style>



// WEBPACK FOOTER //
// App.vue?49d68c89